import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useHistory } from 'react-router-dom';

import './main.css'
import FormFooter from '../../general/FormFooter';

function AddRole() {
    const history = useHistory();
    const [routes, setRoutes] = useState([]);
    const [rolename, setRolename] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [fetchError, setFetchError] = useState('');
    const [permission, setPermission] = useState([]);

    const fetchRoutes = async () => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BACKLINK}/api/public`
            );
            setRoutes(data.mainRoutes);
            setLoading(false);

        } catch (error) {
            setError(error.response.data.msg);
            history.push('/login')
        }
    }

    useEffect(() => {
        fetchRoutes()
    }, [history])

    const handleOnChange = (name) => {
        let permissions = permission
        let find = permissions.indexOf(name)

        if (find > -1) {
            permissions.splice(find, 1);
        } else {
            permissions.push(name);
        }
        setPermission(permissions);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (permission.length === 0) {
            setTimeout(() => {
                setError('')
            }, 5000);
            return setError('Must give some permissions')
        }

        try {
            await axios.post(
                `${process.env.REACT_APP_BACKLINK}/api/private/create-role`,
                {
                    rolename,
                    permissions: permission
                },
                { withCredentials: true }
            );
            history.push('/show-roles');
        } catch (error) {
            setTimeout(() => {
                setError('');
            }, 5000);
            setError(error.response.data.msg);
            await axios.get(
                `${process.env.REACT_APP_BACKLINK}/api/auth/logout`)
            history.push('/login')
        }
    }
    return (
        <>
            {loading ? <h1>Loading...</h1> : fetchError ? (
                <span className="error-message">{fetchError}</span>
            )
                :
                <form onSubmit={handleSubmit}>
                    {error && <h1>{error}</h1>}

                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Role Name:</label>
                            <input type="text" required className="form-control" value={rolename} onChange={e => setRolename(e.target.value)} />
                        </div>
                    </div>

                    <div className="card-body table-responsive p-0 mb-5">
                        <table className="table table-hover text-nowrap">
                            <thead>
                                <tr>
                                    <th>Route</th>
                                    <th>Permission</th>
                                </tr>
                            </thead>
                            <tbody>
                                {routes.map((item) => (
                                    <tr key={item.slug} className="tr">
                                        <td>{item.displayName}</td>
                                        <td>
                                            <div className="custom-control custom-switch">

                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input" id={item.slug}
                                                    onChange={() => handleOnChange(item.slug)}
                                                />
                                                <label className="custom-control-label" htmlFor={item.slug}></label>
                                            </div>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                    <FormFooter button="Add Role" />

                </form>
            }


        </>

    )
}

export default AddRole
